import { createTheme, ThemeProvider } from "@mui/material";
import React from "react";
export const MyTheme = createTheme({
  palette: {
    primary: {
      light: "#7986cb",
      main: "#002744",
      dark: "#0f7489",
      contrastText: "#fff",
    },
    secondary: {
      light: "#ff4081",
      main: "#0f7489",
      dark: "#c51162",
      contrastText: "#fff",
    },
    error: {
      main: "#9D0009",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          ".primary&:hover": {
            backgroundColor: "#085667",
            color: "#ffffff",
          },
          ".primary&:active": {
            backgroundColor: "#085667",
            color: "#ffffff",
          },
          ".primary&:focus": {
            backgroundColor: "#085667",
            color: "#ffffff",
          },
          ".secondary&:active": {
            backgroundColor: "#ABCDD7",
            color: "#004357",
          },
        },
      },
    },
  },
});
export const MyThemeProvider = (props) => {
  return <ThemeProvider theme={MyTheme}>{props.children}</ThemeProvider>;
};
